import React from 'react';

import { Box } from '@chakra-ui/react';

import {
  OutlinedFormCustomField,
  OutlinedFormFieldComponentProps,
} from '../types';

export const CustomField = ({
  field,
  styles,
}: OutlinedFormFieldComponentProps<OutlinedFormCustomField>) => (
  <Box
    opacity={field.isDisabled ? 0.6 : 1}
    {...styles?.value}
    {...field.styles?.value}
  >
    {field.component}
  </Box>
);
